import React, { useState } from "react";
import Box from "@mui/material/Box";
import { useTheme, Tabs, Tab } from "@mui/material";
import Header from "../VersatileComponents/Header";
import EssentialTable from "./table";

const EssentialComponent = ({ isVisible }) => {
  const theme = useTheme();
  const [selectedTab, setSelectedTab] = useState("Asham");

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: "60px",
        left: "50%",
        transform: "translateX(-40%)",
        width: "70vw",
        height: "65vh",
        backgroundColor: theme.palette.background.alt,
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.8)",
        zIndex: 1000,
        visibility: isVisible ? "visible" : "hidden",
        padding: "20px",
        transition: "opacity 0.4s ease-in-out, transform 0.4s ease-in-out",
        opacity: isVisible ? 1 : 0,
      }}
    >
      <Header title="Essentials" subtitle="" />

      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        aria-label="essential tabs"
        sx={{
          mb: 2,
          "& .MuiTabs-indicator": {
            backgroundColor: "white",
          },
        }}
      >
        <Tab
          label="Workers"
          value="Asham"
          sx={{
            color: "white",
            "&.Mui-selected": {
              color: "white",
            },
          }}
        />
        <Tab
          label="Others"
          value="external"
          sx={{
            color: "white",
            "&.Mui-selected": {
              color: "white",
            },
          }}
        />
      </Tabs>

      <EssentialTable companyName={selectedTab} />
    </Box>
  );
};

export default EssentialComponent;
